export default {
  'imposing-the-structure': {
    'course-name': 'Section 1A <span class="unit-title">Imposing the Structure<span>',
    'course-name-pyramid': 'Imposing the Structure',
    'course-video': {
      'title': 'Section 1 THE BASIC PYRAMID <br>00:00 - 54:00 1A WHAT THE COURSE WILL DO <br>-: ex 1A imposing the structure',
      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
      lectureTitle: '1A Lecture'
    },
    'unit-section-title': '1A Exercises',
    'unit-exercise-description': {
      'title': `The first skill you want to develop is the ability to see the existing structure that underlies a piece of writing, particularly the writing of subordinates. You can then look at it critically, as the basis for developing a proper pyramid structure. Following are four typical documents plus their before-and-after structures. Then we show a clearer version of each with a blank pyramid. Can you fill in what the points in the pyramid should be?`,
      'exercise-1': 'Note to Mort (Demo)',
      'exercise-2': 'Retail Price Data Survey',
      'exercise-3': 'Electronic Filing',
      'exercise-4': 'Perfect Team Size',
      'bottom-info': `You will also note that we have stated the essence of the points in each box, using the fewest possible words. This is a technique you will want to employ later, when you begin to build pyramids of your own.`
    },
    'exercise-one': {
      'original-note-title': 'Original note',
      'original-note': `Mort<br>
            <br>
            John Collins telephoned to say that he can’t make the meeting at 3:00. Hal Johnson says he doesn’t mind making it later, or even tomorrow, but not before 10:30, and Don Clifford’s secretary says that Clifford won’t return from Frankfurt until tomorrow, late. The conference room is booked tomorrow, but free Thursday. Thursday at 11:00 looks to be a good time. Is that okay with you?`,

      'clearer-note-title': 'Clearer note',
      'clearer-note': `Mort<br>
            <br>
            Could we reschedule today’s 3:00 meeting to Thursday at 11:00? This would be more convenient for Collins and Johnson, and would permit Clifford to be present. It is also the only other time this week that the conference room is free.`,
      'exercise-number': '1A - Exercise 1',
      'exercise-title': 'Note to Mort (Demo)',
      'task-title': 'Original structure',
      'structured-blocks': {
        'structured-block-1': 'JC-not today <br> HJ-tomorrow after <br> 10:30 <br> DC-not before Thursday',
        'structured-block-2': 'Room not tomorrow <br> Room OK Thursday',
        'structured-block-3': 'Is Thursday OK with you?'
      }
    },
    'exercise-two': {
      'original-note-title': 'Original memo',
      'memo-paper-1': `To:<br> From:
                    <br> Subject: Retail Price Data Survey<br>
                    <br> On April 23 we recommended two enhancements to the
                    reporting characteristics of the Retail Price Data Survey. In addition to these suggestions we recommend
                    that consideration be given to updating the stores actually being surveyed. At the present time we have
                    a considerable number of non-keeper stores (including garages, grocery stores, etc.) being surveyed,
                    which tend to distort the actual market price. Of the 705 Arc Oil stores being surveyed,
                    only 243 or 34% are classified as “A” stores or long-range keepers. These are our high-volume stores,
                    where competitiveness is most important and therefore, we feel the 34% being surveyed do not give us
                    a true reading as to the actual price conditions in our key markets. In fact, we recommend that consideration
                    be given to surveying only “A” type stores. Obviously, if we modify the Arc Oil surveyed stores, we will
                    also have to modify the competitive stores to make them compatible. <br>
                    <br> Finally, we recommend that the program’s built-in 50-50 ratio for self-serve be modified to 70-30,
                    which is more in line with current experience. <br>
                    <br> Mort, the increasing importance of the RPDS makes it imperative that we take whatever steps necessary
                    to ensure that the data surveyed is truly reflective of the marketplace. <br>
                    <br> Your assistance will be appreciated.`,
      'exercise-number': '1A - Exercise 2',
      'exercise-title': 'Retail Price Data Survey',
      'task-title-leftcolumn': 'Clearer memo',
      'memo-paper-2': `To:<br> From:
                    <br> Subject: Retail Price Data Survey <br>
                    <br> As you know, the increasing importance of the RPDS makes it imperative that the data collected truly
                    reflect the marketplace. To this end, we recommend that consideration be given to updating the stores
                    actually being surveyed, as follows: <br>
                    <br>
                    <b>1. Survey only “A” type stores.</b> At the present time we have a considerable number of nonkeeper
                    stores (including garages, grocery stores, etc.) being surveyed, which tends to distort the actual market
                    price. Of the 705 Arc Oil stores being surveyed, only 243 or 34% are classified as “A” stores (or long-range
                    keepers). These are our high-volume stores where competitiveness is most important. Surveying only 34%
                    does not give us a true reading of the actual price conditions in our key markets.<br>
                    <br>
                    <b>2. Shift the competitive stores to match.</b> Obviously if we modify the Arc Oil surveyed stores,
                    we will also have to modify competitive stores to make them compatible.<br>
                    <br>
                    <b>3. Change the self-serve ratio from 50-50 to 70-30.</b> This figure is more in line with current experience.<br>
                    <br> Your assistance is very much appreciated.
                    <br>
                    <br>
                    <br>
                    <br>`,
    },
    'exercise-three': {
      'original-note-title': 'Original memo',
      'memo-paper-1': `<b>ELECTRONIC FILING</b><br>
                    <br> Despite its inherent benefits, there are questions about the practicality and cost-effectiveness
                    of electronic filing. Perceived barriers to adoption are:<br>
                    <br>
                    <b>1.	 Organizational</b><br> a. No single point of responsibility for documents (information) as an
                    organizational resource <br> b. Systematic sharing of files requires behavioral changes <br> c. There
                    is no organizational awareness of the real costs associated with document handling <br> d. Electronic
                    filing is an organizational concept, not just task automation<br>
                    <br>
                    <b>2.	 Information indexing need</b><br> a. Indexing standards are essential - “new role.” <br> b. People
                    won’t tolerate indexing as an add-on task, separate from document creation (or receipt, if it is e-mail)
                    <br> c. Content analysis for indexing/retrieval is highly desired<br>
                    <br>
                    <b>3. 	Technology</b><br> a. There has been insufficient penetration of personal workstation use
                    <br> b. Technology inserted between individuals and files is potentially threatening<br>
                    <br>
                    <b>4.		Benefits</b><br> a. Cost performance and functionality are not sufficient to meet identified needs
                    <br> b. There is no compelling business need... and many subtle costs associated with electronic filing
                    <br> c. Decision makers don’t think filing is a problem <br>`,
      'exercise-number': '1A - Exercise 3',
      'exercise-title': 'Electronic Filing',
      'task-title-fullwidth': 'Original discussion agenda',
      'task-title-leftcolumn': 'Clearer Agenda',
      'memo-paper-2': `ELECTRONIC FILING <br>
                    <br> Businesses are unlikely to adopt electronic filing in the near future. <br>
                    <br> 1. Decision makers don’t think filing is a problem <br>
                    <ul>
                      <li>They have no awareness of the real cost</li>
                      <li>There is no organizational way for them to become aware</li>
                    </ul>
                    <br> 2. Systems available are expensive and not very effective <br>
                    <br> 3. Utilizing them would require enormous, costly behavioral change that people are unlikely to accept
                    <br>
                    <ul>
                      <li>They will not want to be separated from their files</li>
                      <li>They will not easily accept the need to share files</li>
                      <li>They will not tolerate indexing as an add-on task</li>
                    </ul>
                    <br>
                    <br>
                    <br>`,
    },
    'exercise-four': {
      'exercise-number': '1A - Exercise 4',
      'exercise-title': 'Perfect Team Size',
      'task-title-fullwidth': 'Original newspaper article',
      'memo-paper-1': `WITH TEAMS, MANY HANDS DO NOT MAKE LIGHT WORK <br>
                    <br> Numerous studies confirm that, when it comes to teams, four to six members is the best team size
                    for most tasks, that no work team should have more than ten members, and that performance problems increase
                    “exponentially as team size increases.” These troubles arise because large teams place an often overwhelming
                    “cognitive load” on members. Most of us are able to mesh our efforts and maintain good personal relationships
                    with, say, three or four teammates. But as a group expands, each member devotes more time to coordination
                    of chores (and less time to actually doing the work), more handovers between members are required (creating
                    opportunities for miscommunication and mistakes), and because each member must divide his or her attention
                    among a longer list of colleagues, the team’s social glue weakens (and destructive conflict soars).<br>`,
      'task-title-fullwidth-2': 'Clearer article',
      'memo-paper-2': `WITH TEAMS, MANY HANDS DO NOT MAKE LIGHT WORK <br>
                    <br> Numerous studies confirm that four to six members is the best team size for most tasks, and that
                    no work team should have more than 10 members. Performance problems inevitably increase with team size,
                    as more time is required for organization and explanation, the time available to do the work decreases,
                    and chances of destructive conflict grow. <br>
                    <br> As a group expands, each member devotes more time to coordinating chores and to performing handovers
                    to each other. There is thus less time to do the actual work, but many more opportunities for miscommunication
                    and mistakes, so that they do the work less efficiently. And because each member must divide his or her
                    personal attention among a longer list of colleagues, the team’s social glue weakens, and the sense
                    of enjoyment in being part of the group diminishes.
                    <br>
                    <br>`,
    },
    'congratulation-message': 'THANK YOU',
    'finish-section': 'You have completed Section 1A',
    'final-description': 'You see that arranging ideas in a pyramid allows you to see the thinking more clearly',
    'next-course-button': 'Proceed to 1B',
    'dashboard-button': 'Main menu',
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/1/1a/imposingTheStructure/i18n/en.js